import styles from '../CartCheckout.module.scss';

export const CartCheckoutStepper = ({ steps, activeStep, setActiveStep }) => {
  return (
    <>
      <div className={styles.stepper}>
        {steps.map((step, index) => (
          <div className={styles.step} key={index}>
            <img src={step.image} alt={step.title} />
            <div style={{ fontWeight: "600" }}>{step.title}</div>
          </div>
        ))}
      </div>
      <div className={styles.stepper_dots}>
        <div
          className={
            activeStep === 0 ||
            activeStep === 1 ||
            activeStep === 2 ||
            activeStep === 3 ||
            activeStep === 4
              ? `${styles.dot_circle} ${styles.dot_circle_active}`
              : styles.dot_circle
          }
        />
        <div
          className={
            activeStep === 1 ||
            activeStep === 2 ||
            activeStep === 3 ||
            activeStep === 4
              ? `${styles.line_1} ${styles.line_1_active}`
              : styles.line_1
          }
        />
        <div
          className={
            activeStep === 1 ||
            activeStep === 2 ||
            activeStep === 3 ||
            activeStep === 4
              ? `${styles.dot_circle} ${styles.dot_circle_active}`
              : styles.dot_circle
          }
        />
        <div
          className={
            activeStep === 2 || activeStep === 3 || activeStep === 4
              ? `${styles.line_2} ${styles.line_2_active}`
              : styles.line_2
          }
        />
        <div
          className={
            activeStep === 3 || activeStep === 4
              ? `${styles.dot_circle} ${styles.dot_circle_active}`
              : styles.dot_circle
          }
        />
        <div
          className={
            activeStep === 3 || activeStep === 4
              ? `${styles.line_3} ${styles.line_3_active}`
              : styles.line_3
          }
        />
        <div
          className={
            activeStep === 3 || activeStep === 4
              ? `${styles.dot_circle} ${styles.dot_circle_active}`
              : styles.dot_circle
          }
        />
        <div
          className={
            activeStep === 4
              ? `${styles.line_4} ${styles.line_4_active}`
              : styles.line_4
          }
        />

        <div
          className={
            activeStep === 4
              ? `${styles.dot_circle} ${styles.dot_circle_active}`
              : styles.dot_circle
          }
        />
      </div>
    </>
  );
};
